import dayjs from 'dayjs';
import { DATE_FORMAT } from 'vio-constants';

import { IMapFeatureLayer, IMapFeatureRow, IMapFeatureSource } from '../interfaces';

import { convertToFiberName, isBackboneFiber } from '.';

export const getSourceTableRows = (sources: Array<IMapFeatureSource>, layers: Array<IMapFeatureLayer>): Array<IMapFeatureRow> =>{
	return sources.map((source): IMapFeatureRow => {
		const layer = layers.find((layer) => convertToFiberName(layer.name) === source.data.source_layer);
		const {
			created_at: sourceCreatedDate,
			future,
			id,
			name,
			updated_at: sourceUpdatedDate
		} = source;

		// display whichever updated date is more recent
		let newestUpdatedDate = sourceUpdatedDate ? new Date(sourceUpdatedDate).getTime() : 0;

		if (layer) {
			const {
				created_at: layerCreatedDate,
				updated_at: layerUpdatedDate
			} = layer;

			// If a fiber has been re-uploaded then the old one is deleted before a new one is uploaded.
			// So if layerUpdatedDate does not exist it means that the layer has been re-created so we
			// use layerCreatedDate instead to to compare the most recently updated date.
			const layerUpdatedAt = new Date(layerUpdatedDate ? layerUpdatedDate : layerCreatedDate).getTime();

			newestUpdatedDate = Math.max(newestUpdatedDate, layerUpdatedAt);
		}

		const createdDate = dayjs(new Date(sourceCreatedDate).getTime()).format(DATE_FORMAT.DATE_AND_TIME);
		const updatedDate = newestUpdatedDate > new Date(sourceCreatedDate).getTime() ? dayjs(newestUpdatedDate).format(DATE_FORMAT.DATE_AND_TIME) : '';

		return {
			backbone: isBackboneFiber(name),
			createdDate,
			future,
			id,
			layer,
			name,
			source,
			type: layer ? layer.tile_name : 'fiber',
			updatedDate
		};
	});
};

export const getOrphanedLayerTableRows = (sources: Array<IMapFeatureSource>, layers: Array<IMapFeatureLayer>): Array<IMapFeatureRow> => {
	const rows = [];

	layers.map((layer) => {
		const {
			created_at: createdDate,
			id,
			name,
			tile_name: type,
			updated_at: updatedDate
		} = layer;

		const associated = sources.find((source) => source.data.source_layer === convertToFiberName(name));

		if (!associated) {
			rows.push({
				createdDate,
				id,
				layer,
				name,
				type,
				updatedDate
			});
		}
	});

	return rows;
};

